












































































/* eslint-disable */
import { Component, Emit, Prop, Watch, Vue } from 'vue-property-decorator'
import CalculadoraVuex from '@/store/CalculadoraVuex'

@Component

export default class ComponentCalculadoraFooter extends Vue {
  @Prop(Object) valorConsolidado
  @Prop(Boolean) dialogSelectTabela
  @Prop(Array) portes
  @Prop(Array) procedimentos
  @Prop(Object) tabela
  @Prop(Array) tabelasCBHPM

  porteActive: any = {}
  tabelaActive: any = {}

  mounted() {
    this.setTabelaActive()
    this.setPorteActive()
  }

  @Watch('tabela', { deep: true })
  onTabelaChanged() {
    this.setTabelaActive()
    this.setPorteActive()
  }

  @Emit('showDialogSelectTabela')
  showDialogSelectTabela() {}

  @Emit('showDialogShowValores')
  showDialogShowValores() {
    CalculadoraVuex.dispatch('SET_SHOW_CACULADORA_DIALOG_SHOW_VALORES', true)
  }

  @Emit('toggleModalAddProcedimento')
  toggleModalAddProcedimento() {
  }

  getCurrency(value) {
    return (this.$options as any).filters.currency(value)
  }

  setPorteActive() {
    if (this.portes.length > 0) {
      this.portes.map((porte) => {
        if (this.tabela.dataReferenciaPorte === porte.dataReferencia) {
          this.porteActive = porte
        }
      })
    }
  }

  setTabelaActive() {
    if (this.tabelasCBHPM.length > 0) {
      this.tabelasCBHPM.map((tabela) => {
        if (this.tabela.codigoTabelaReferencia === tabela.codigoTabelaReferencia) {
          this.tabelaActive = tabela
        }
      })
    }
  }

  get ativarTabelaCBHPM() {
    return CalculadoraVuex.getters.ATIVAR_VALORES_TABELA_CBHPM
  }
}
